<template>
<div class="tab-inner-left">
  <div class="form-module" style="min-height: 500px">
    <h2>Privacy Policy</h2>
    <p class="py-4">According to the law, you must have a legal confidentiality agreement stating the purpose for which you will use this data you collect from users. Users must accept this text you provide before sharing their information.</p>
    <vue-editor @input="update_data('privacy')" type="text" @focus="privacy_focused = true"
           @blur="privacy_focused = false" v-model="privacy"
           placeholder="Enter privacy policy text here..."
           ref="Privacy Policy"
           name="Privacy Policy"
           data-vv-name="Privacy Policy"
           v-validate="'required'"
    />
    <span class="text-danger text-sm" v-show="errors.has('Privacy Policy')">{{ errors.first('Privacy Policy') }}</span>
  </div>
 </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

import UploadImage from '../../../../layouts/components/navbar/UploadImage'
export default {
  props: {
    update: {
      type: Function
    },
    dataVal: {
      type: Object
    }
  },
  data () {
    return {
      create: true,
      dataImg: require('@/assets/images/logo/logo.png'),
      uploadImg: null,
      privacy: '',
      privacy_focused: false
    }
  },
  components: {
    UploadImage,
    VueEditor
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    this.set_data()
  },
  watch: {
    privacy_focused () {
      this.update_data('privacy')
    },
    dataVal () {
      this.set_data()
    }
  },
  computed: {
    post_detail () {
      return this.$store.state.post_detail
    }
  },
  methods: {
    set_data () {
      const { privacy } = JSON.parse(JSON.stringify(this.dataVal))
      this.privacy = privacy

      console.log('setting data', this.dataVal)
    },
    update_data (ref) {
      this.update(this.privacy)
      this.$store.commit('SET_EDITING_NOW', ref)

    }
  }
}
</script>
<style lang="scss">
</style>
